<template>
    <div class="border rounded p-4 mb-3 mt-4 w-100">
    <ValidationObserver ref="ConfirmationFormObserver">
        <div class="row">
            <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-6">
                <ValidationProvider name="good_standing"
                                    :rules="['approved'].includes(mentoraAdminStep.status)?'required':''"
                                    v-slot="{ valid, errors }">
                    <b-form-group :label="$t('good_standing')">
                        <true-false-selectbox
                            v-model="mentoraAdminStep.good_standing"
                            :validate-error="errors[0]"
                        />
                    </b-form-group>
                </ValidationProvider>
            </div>
            <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-6">
                <ValidationProvider name="status" rules="required" v-slot="{ valid, errors }">
                    <b-form-group :label="$t('status')">
                        <multi-selectbox
                            :multiple="false"
                            v-model="mentoraAdminStep.status"
                            :options="statusOptions"
                            :validate-error="errors[0]"
                        />
                    </b-form-group>
                </ValidationProvider>
            </div>
            <div class="col-12 col-md-6 col-lg-6 col-xl-6" v-if="['declined'].includes(mentoraAdminStep.status)">
                <ValidationProvider name="reason" :rules="['declined'].includes(mentoraAdminStep.status)?'required':''" v-slot="{valid, errors}">
                    <b-form-group :label="$t('reason')">
                        <b-form-textarea v-model="mentoraAdminStep.denial_explanation"
                                         :class="errors[0] ? 'is-invalid':''"
                                         rows="5"
                        />
                        <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                    </b-form-group>
                </ValidationProvider>
            </div>
            <b-col cols="12" class="d-flex justify-content-center">
                <ProcessingButton
                    :css-class="'text-center'"
                    :processing="isLoading"
                    :label="$t('save')"
                    v-if="checkPermission('studentoutofcountryrequest_mentoraadmin_review')"
                    @click="confirmationStep"/>
            </b-col>
        </div>
    </ValidationObserver>
    </div>
</template>

<script>
import TrueFalseSelectbox from "@/components/interactive-fields/TrueFalseSelectbox.vue";
import MultiSelectbox from "@/components/interactive-fields/MultiSelectbox.vue";
import ProcessingButton from "@/components/elements/ProcessingButton.vue";
import OutOfCountryMentora from "@/services/OutOfCountryMentoraServices";

export default {
    name: "ConfirmationForm",
    components: {ProcessingButton, MultiSelectbox, TrueFalseSelectbox},
    data(){
        return {
            mentoraAdminStep:{},
            isLoading:false,
            statusOptions: [
                {value: null, text: ''},
                {value: 'approved', text: this.$t('approved')},
                {value: 'declined', text: this.$t('declined')},
            ],
        }
    },
    methods:{
        async confirmationStep(){
            const isValid = await this.$refs.ConfirmationFormObserver.validate();
            if (!isValid) return
            try {
                const data ={
                    good_standing: this.mentoraAdminStep.good_standing,
                    status:this.mentoraAdminStep.status
                }
                if (this.mentoraAdminStep.status==='declined'){
                    data.denial_explanation=this.mentoraAdminStep.denial_explanation
                }
                const res =await OutOfCountryMentora.confirmationUpdateStep(this.$route.params.id,data)
                this.$toast.success(this.$t('api.'+res.data.message))
                this.$emit('successReview',true)
            }catch (err){
                this.showErrors(err, this.$refs.ConfirmationFormObserver)
            }
        },
    }
}
</script>

<style scoped>

</style>
